export default `

const float PI = 3.1415926535897932384626433832795;

float hash(float n) { return fract(sin(n) * 1e4); }
float hash(vec2 p) { return fract(1e4 * sin(17.0 * p.x + p.y * 0.1) * (0.1 + abs(sin(p.y * 13.0 + p.x)))); }

float randLine(float x) {
	float i = floor(x);
	float f = fract(x);
	float u = f * f * (3.0 - 2.0 * f);
	return mix(hash(i), hash(i + 1.0), u);
}

float noise(float x) {
    return abs(fract(sin(dot(vec2(x / 20000.0, x / 20000.0) ,vec2(12.9898,78.233))) * 43758.5453));
}

vec3 permute(vec3 x) { return mod(((x*34.0)+1.0)*x, 289.0); }

float snoise(vec2 v){
  const vec4 C = vec4(0.211324865405187, 0.366025403784439,
           -0.577350269189626, 0.024390243902439);
  vec2 i  = floor(v + dot(v, C.yy) );
  vec2 x0 = v -   i + dot(i, C.xx);
  vec2 i1;
  i1 = (x0.x > x0.y) ? vec2(1.0, 0.0) : vec2(0.0, 1.0);
  vec4 x12 = x0.xyxy + C.xxzz;
  x12.xy -= i1;
  i = mod(i, 289.0);
  vec3 p = permute( permute( i.y + vec3(0.0, i1.y, 1.0 ))
  + i.x + vec3(0.0, i1.x, 1.0 ));
  vec3 m = max(0.5 - vec3(dot(x0,x0), dot(x12.xy,x12.xy),
    dot(x12.zw,x12.zw)), 0.0);
  m = m*m ;
  m = m*m ;
  vec3 x = 2.0 * fract(p * C.www) - 1.0;
  vec3 h = abs(x) - 0.5;
  vec3 ox = floor(x + 0.5);
  vec3 a0 = x - ox;
  m *= 1.79284291400159 - 0.85373472095314 * ( a0*a0 + h*h );
  vec3 g;
  g.x  = a0.x  * x0.x  + h.x  * x0.y;
  g.yz = a0.yz * x12.xz + h.yz * x12.yw;
  return 130.0 * dot(m, g);
}

float quadraticInOut(float t) {
    float p = 2.0 * t * t;
    return t < 0.5 ? p : -p + (4.0 * t) - 1.0;
  }

  float circularInOut(float t) {
    return t < 0.5
      ? 0.5 * (1.0 - sqrt(1.0 - 4.0 * t * t))
      : 0.5 * (sqrt((3.0 - 2.0 * t) * (2.0 * t - 1.0)) + 1.0);
  }
  
  float exponentialOut(float t) {
    return t == 1.0 ? t : 1.0 - pow(2.0, -10.0 * t);
  }

  float linear(float t) {
      return t;
  }

  float smooth(float t) {
      return smoothstep(0.0, 1.0, t);
  }

  float exponentialInOut(float t) {
    return t == 0.0 || t == 1.0
      ? t
      : t < 0.5
        ? +0.5 * pow(2.0, (20.0 * t) - 10.0)
        : -0.5 * pow(2.0, 10.0 - (t * 20.0)) + 1.0;
  }

  float coolCurve(float t) {
      return t < 0.5 
        ? circularInOut(circularInOut(t * 2.0)) / 2.0 
        : circularInOut(circularInOut(t * 2.0 - 1.0)) / 2.0 + 0.5;
  }


uniform float volume;
uniform float colourState;
uniform float shapeState;
uniform float time;

varying float vDist;
varying float vColourState;
varying float vCircleAlpha;

const float RADIUS = 130.0;

void main() {

    vColourState = colourState;
    gl_PointSize = 1.0;

    float index = position.x * 1.0;
    float curved = linear(index);

    float angle = curved * PI * 2.0;

    float staticNoise = noise(index * 600.0) * 0.8;
    float timeNoise = noise(index + (0. * 4.0) * 4.0) * 0.0;
    float totalNoise = (staticNoise + timeNoise);

    float distMult = exponentialOut(noise((index * 10000.0) + (0. * 0.13))) * 0.85;
    float dist = distMult * RADIUS - totalNoise;

    float x = cos(angle) * dist;
    float y = sin(angle) * dist;

    vec2 circlePosition = vec2(x, y);


    float xAmt = abs(x) / RADIUS;
    float yAmt = abs(y) / RADIUS * (xAmt);
    float baseAlpha = (xAmt + yAmt) * 0.4;

    float circleAlpha = baseAlpha + exponentialInOut(snoise(circlePosition + vec2(time * 0.5))) * 0.5;

    // -----------------------

    float ringIndex = index * 20.0;
    float ringAngle = ringIndex * PI * 2.0;
    float testVol = sin(time * 6.0);
    float adjustVol = clamp(volume * 3.0, 0.0, 1.0);
    float ringInnerRadius = mix(RADIUS * 0.7, RADIUS * 0.9, adjustVol);
    float ringWidth = mix(0.15, 0.3, adjustVol) * RADIUS * mix(noise(ringAngle * 30.1), snoise(vec2(ringAngle * 0.3, ringAngle * 0.3)), exponentialOut(adjustVol));
    float ringOuterRadius = ringInnerRadius + ringWidth;

    float bx = cos(ringAngle) * ringInnerRadius;
    float xNoise = mix(
      snoise(vec2(ringIndex * 16.0 + (time * 0.3), ringIndex * 16.0)),
      randLine(ringIndex * 16.0 + (time * 0.3)) - 0.5,
      exponentialOut(adjustVol)
    );
    float rx = xNoise * ringWidth;
    float by = sin(ringAngle) * ringInnerRadius;
    float yNoise = mix(
      snoise(vec2(ringIndex * 8.0 + (time * 0.3), ringIndex * 4.0)),
      randLine( ringIndex * 8.0 + (time * 0.3) ) - 0.5,
      exponentialOut(adjustVol)
    );
    float ry = yNoise * ringWidth;

    vec2 ringPosition = vec2(
        bx + rx,
        by + ry
    );

    

    vDist = mix(distMult, sqrt(pow(ringPosition.x, 2.0) + pow(ringPosition.y, 2.0)) / ringOuterRadius, shapeState);
    
    // --------------
    vec2 mixedPosition = mix(circlePosition, ringPosition, shapeState);
    vCircleAlpha = mix(circleAlpha, 0.2, shapeState);

    gl_Position = projectionMatrix
        * modelViewMatrix
        * vec4(mixedPosition, 0.0, 1.0);
}
`;
